import { styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Button, Container, Divider, Icon, Paper, RubricTable, Stack, Tag, Text } from 'shell/components';
import { FEEDBACK_LIMIT } from 'utils/constants';

const Mobile = ({ assignment, batch, formative, studentSubmissions, onClickBack, onClickProceed }) => {
    const { t } = useTranslation('assignment');

    return (
        <Container device={'mobile'}>
            <CustomStack alignItems={'flex-start'} spacing={5}>
                <Button startIcon={<Icon kind={'arrowLeft'} />} variant={'borderless'} onClick={onClickBack}>
                    {t('common:controls.back', 'Back')}
                </Button>
                <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                    {assignment.title}
                </Text>
                <CustomPaper elevation={0}>
                    <Stack divider={<Divider />} spacing={4}>
                        <Stack spacing={4}>
                            <Stack spacing={2}>
                                <Tag
                                    type={'attempts'}
                                    value={FEEDBACK_LIMIT - (studentSubmissions.length + batch.length)}
                                />
                                <Text component={'p'} variant={'h6'} weight={'medium'}>
                                    Formative Feedback for Students
                                </Text>
                                <Stack spacing={5}>
                                    <Text>
                                        {t(
                                            'feedback-section.instant-student-feedback.how-it-works-description',
                                            "TimelyGrader AI utilizes the assignment rubric and examples of your instructor's feedback to deliver personalized feedback tailored to this deliverable. This gives you a chance to get feedback and improve your work before you submit!"
                                        )}
                                    </Text>
                                    <Text>
                                        {t(
                                            'feedback-section.instant-student-feedback.important-note',
                                            "Important: Submitting drafts is not considered your final submission. Please submit your final work as per your instructor's instructions."
                                        )}
                                    </Text>
                                </Stack>
                            </Stack>
                            <Button onClick={onClickProceed}>{formative ? 'Continue' : 'Begin'}</Button>
                        </Stack>
                    </Stack>
                </CustomPaper>
                <CustomPaper elevation={0}>
                    <Stack spacing={5}>
                        <Stack spacing={2}>
                            <Text>{t('assignment-description-label', 'Assignment Description')}</Text>
                            {assignment.description ? (
                                <Text color={'light'} rich>
                                    {assignment.description}
                                </Text>
                            ) : (
                                <Text color={'light'}>{t('common:ui.none', 'None')}</Text>
                            )}
                        </Stack>
                        <Stack spacing={2}>
                            <Text>{t('assignment-rubric-label', 'Assignment Rubric')}</Text>
                            {assignment.rubric ? (
                                <RubricTable isExpanded type={'view'} data={assignment.rubric.criteria} />
                            ) : (
                                <Text color={'light'}>{t('common:ui.none', 'None')}</Text>
                            )}
                        </Stack>
                    </Stack>
                </CustomPaper>
            </CustomStack>
        </Container>
    );
};

const CustomStack = styled(Stack)(({ theme }) => {
    return {
        width: '100%',
        paddingBottom: theme.spacing(5),
    };
});

const CustomPaper = styled(Paper)(({ theme }) => {
    return {
        borderRadius: '12px',
        width: '100%',
        padding: theme.spacing(5),
    };
});

export default Mobile;
